import React, { useCallback, useEffect, useState } from 'react';
import i18next from 'i18next';

import { TextInput } from '../TextInput';
import moment from 'moment';

const ChecklistScheduleTime = ({ timeLabel, onSubmit, onCancel }) => {    
    const [labelName, setLabelName] = useState(timeLabel?.label ?? '');
    const [scheduleOrder, setScheduleOrder] = useState(timeLabel ? timeLabel.scheduleOrder + 1 : '');
    const [wallTime, setWallTime] = useState("");
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (timeLabel?.timeOfDay) {
            setWallTime(moment.unix(timeLabel.timeOfDay).utc().format("HH:mm"));
        }
    }, [timeLabel]);

    const handleSubmit = useCallback((event) => {
        event.preventDefault();

        let containsErrors = false;
        let localErrors = {};

        if (labelName === '') {
            containsErrors = true;
            localErrors.label = i18next.t('messages.please-enter-time');
        }

        if (scheduleOrder < 1) {
            containsErrors = true;
            localErrors.scheduleOrder = i18next.t('messages.please-enter-order');
        }

        var timeOfDay = null;
        if (wallTime != '') {
            const mTime = moment(wallTime, ['h:m a', 'H:m']);
            if (mTime.isValid()) {
                timeOfDay = ((mTime.hours() * 60) + mTime.minute()) * 60;
            } else {
                containsErrors = true;
                localErrors.wallTime = "Time of day is not in a valid format. Try HH:mm";
            }
        }

        if (containsErrors) {
            setErrors(localErrors);
        } else {
            onSubmit({ 
                uid: timeLabel?.uid,
                id: timeLabel?.id, 
                label: labelName, 
                timeOfDay: timeOfDay,
                scheduleOrder: scheduleOrder 
            });
        }
    }, [labelName, scheduleOrder, wallTime, onSubmit]);

    return (  
        <div className="login-form">
            <form onSubmit={handleSubmit}>

                <TextInput 
                    input={{
                        value: labelName, 
                        onChange: event => setLabelName(event.target.value),
                        autoFocus: true
                    }}
                    type="text"
                    label={i18next.t('form-labels.time-of-day')}
                    meta={errors.label ? {touched: true, error: errors.label} : {}}
                />

                <TextInput 
                    input={{
                        value: scheduleOrder, 
                        onChange: event => setScheduleOrder(event.target.value)
                    }}
                    type="text"
                    label={i18next.t('form-labels.order')}
                    meta={errors.scheduleOrder ? {touched: true, error: errors.scheduleOrder} : {}}
                />

                <TextInput 
                    input={{
                        value: wallTime, 
                        onChange: event => setWallTime(event.target.value)
                    }}
                    type="text"
                    label="Wall Time (Optional)"
                    meta={errors.wallTime ? {touched: true, error: errors.wallTime} : {}}
                />

                <hr/>

                <ul className="list-inline clearfix">
                    <li><button type="submit" className="btn btn-primary btn-block">{i18next.t('form-labels.save')}</button></li>
                    <li><button type="button" className="btn btn-default" onClick={onCancel}>{i18next.t('form-labels.cancel')}</button></li>
                </ul>
            </form>
        </div>
    );
}

export default ChecklistScheduleTime;